

var _uiRouter = require("uiRouter");
var _core = require("../core");
_core.$event.on('pxp_res', function (event, pxpRes) {
  _uiRouter.$state.current.trackingData = _uiRouter.$state.current.trackingData || {};
  _uiRouter.$state.current.trackingData.pxpData = _uiRouter.$state.current.trackingData.pxpData || [];
  _uiRouter.$state.current.trackingData.pxpData.push(pxpRes);
});
_uiRouter.$state;
_core.$event;


//////////////////
// WEBPACK FOOTER
// ../node_modules/squid/dist/ng/pxp.js
// module id = ../node_modules/squid/dist/ng/pxp.js
// module chunks = 0